import type { Prodotto } from '@/types'

const hay = (p: Prodotto) =>
  `${p.codice} ${p.nome} ${p.cte_filename ?? ''}`.toUpperCase()

/**
 * Linea Estenergy: in anagrafica prodotto compare **ESTHERA** (non confondere con **HERA**:
 * "ESTHERA" contiene la sottostringa "HERA").
 */
function isEstenergyLineProduct(p: Prodotto): boolean {
  const s = hay(p)
  return (
    s.includes('ESTHERA') ||
    s.includes('ESTENERGY') ||
    s.includes('EST-ENERGY') ||
    s.includes('EST_ENERGY') ||
    s.includes('EENE')
  )
}

/**
 * Linea Heracomm / Hera: presenza di **HERA** escludendo i nomi **ESTHERA**.
 */
function isHeraLineProduct(p: Prodotto): boolean {
  const s = hay(p)
  if (isEstenergyLineProduct(p)) return false
  return (
    s.includes('HERA') ||
    s.includes('HERACOMM') ||
    s.includes('HERA_HYBRID') ||
    s.includes('HERA HYBRID') ||
    s.includes('_HC_') ||
    s.includes(' HC ')
  )
}

/**
 * Sceglie l'id prodotto coerente con la società di copertura (Heracomm vs Estenergy).
 * Se `company` è assente (es. fallback dopo errore API), si assume **Heracomm**.
 */
export function resolveProdottoIdByCompany(
  prodotti: Prodotto[],
  company: 'heracomm' | 'estenergy' | null | undefined,
  commodity: 'luce' | 'gas',
): number | null {
  const list = prodotti.filter((p) => p.commodity === commodity)
  if (list.length === 0) return null
  if (list.length === 1) return list[0].id

  const effective: 'heracomm' | 'estenergy' = company === 'estenergy' ? 'estenergy' : 'heracomm'

  if (effective === 'estenergy') {
    const m =
      list.find(isEstenergyLineProduct) ??
      list.find((p) => !isHeraLineProduct(p))
    return (m ?? list[0]).id
  }

  const m =
    list.find(isHeraLineProduct) ??
    list.find((p) => !isEstenergyLineProduct(p))
  return (m ?? list[0]).id
}
